import { motion } from 'framer-motion';
import dashboardImg from '../assets/leaflet-system-dashboard.png';
import analyticsImg from '../assets/analytics-dashboard.jpeg';
import teamImg from '../assets/team-partnership.jpeg';

const modules = [
  {
    number: '01',
    title: '24小時自動成交網店',
    before: '客人填表單等 Email，人工對帳耗時數小時。',
    after: '即時創建訂單，WhatsApp 一鍵發送，後端自動確認，付款憑證即時顯示。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
      </svg>
    ),
  },
  {
    number: '02',
    title: '推薦夥伴自動分銷系統',
    before: '口頭推薦無法追蹤，Excel 手動計算佣金容易出錯。',
    after: '專屬短連結自動歸因，永久綁定推薦人，自動計算 10% 回贈，專屬 Dashboard 即時查看。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    number: '03',
    title: '自動化廣播與精準再行銷',
    before: '手動一個一個發 WhatsApp，亂槍打鳥又容易被封鎖。',
    after: '後台依標籤分群自動分批發送，內建隨機間隔防封鎖機制。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
  },
  {
    number: '04',
    title: '全站流量與轉化儀表板',
    before: '靠 Google Analytics 猜數據，憑感覺下廣告。',
    after: '自有數據一目瞭然，每個夥伴的點擊、訪客、成交、營收清晰透明。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
];

export default function SolutionSection() {
  return (
    <section className="relative py-24 lg:py-32 bg-warm-200 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-hermes-100 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-hermes-50 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-flex items-center gap-2 text-hermes-700 font-bold text-sm uppercase tracking-wider mb-4">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            降維打擊
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-hermes-900 mb-4">
            自動銷售系統的
            <span className="text-gradient">「四大核心戰術模組」</span>
          </h2>
          <p className="text-lg text-warm-500 max-w-3xl mx-auto">
            月營收 = 流量 × 轉化率 × 客單價 × 回購裂變倍數 — 我們幫你四個變數同時優化！
          </p>
        </motion.div>

        {/* Formula display */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-hermes-800 to-hermes-900 rounded-2xl p-6 mb-16 text-center"
        >
          <div className="flex flex-wrap items-center justify-center gap-3 text-white font-mono text-sm sm:text-base">
            <span className="bg-white/10 px-3 py-1.5 rounded-lg">月營收</span>
            <span className="text-hermes-400">=</span>
            <span className="bg-hermes-500/20 border border-hermes-500/30 px-3 py-1.5 rounded-lg">流量</span>
            <span className="text-hermes-400">×</span>
            <span className="bg-hermes-500/20 border border-hermes-500/30 px-3 py-1.5 rounded-lg">轉化率</span>
            <span className="text-hermes-400">×</span>
            <span className="bg-hermes-500/20 border border-hermes-500/30 px-3 py-1.5 rounded-lg">客單價</span>
            <span className="text-hermes-400">×</span>
            <span className="bg-hermes-500/20 border border-hermes-500/30 px-3 py-1.5 rounded-lg">回購裂變</span>
          </div>
        </motion.div>

        {/* Visual showcase row - analytics + team images */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16"
        >
          <div className="relative group overflow-hidden rounded-2xl">
            <img
              src={analyticsImg}
              alt="數據分析儀表板 - 精準追蹤轉化"
              className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-hermes-900/80 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <p className="text-white font-bold">即時數據追蹤</p>
              <p className="text-white/70 text-sm">每一筆流量、轉化都清晰可見</p>
            </div>
          </div>
          <div className="relative group overflow-hidden rounded-2xl">
            <img
              src={teamImg}
              alt="團隊合作夥伴 - 自動分銷網絡"
              className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-hermes-900/80 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <p className="text-white font-bold">夥伴網絡裂變</p>
              <p className="text-white/70 text-sm">自動化分銷讓客戶幫你帶客戶</p>
            </div>
          </div>
        </motion.div>

        {/* Module cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-16">
          {modules.map((module, index) => (
            <motion.div
              key={module.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="group bg-warm-100 hover:bg-warm-50 rounded-2xl p-8 border border-warm-300 hover:border-hermes-400/40 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-hermes-700 to-hermes-800 text-white rounded-xl flex items-center justify-center">
                  {module.icon}
                </div>
                <div>
                  <span className="text-xs font-bold text-hermes-500/60 tracking-wider">MODULE {module.number}</span>
                  <h3 className="text-xl font-bold text-hermes-900 mt-1">{module.title}</h3>
                </div>
              </div>

              {/* Before / After comparison */}
              <div className="space-y-3">
                <div className="flex items-start gap-3 bg-hermes-50 rounded-xl p-4">
                  <span className="flex-shrink-0 w-6 h-6 bg-hermes-100 text-hermes-500 rounded-full flex items-center justify-center text-xs font-bold">✕</span>
                  <div>
                    <span className="text-xs font-bold text-hermes-500/70 uppercase tracking-wider">Before</span>
                    <p className="text-sm text-warm-600 mt-0.5">{module.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-green-50 rounded-xl p-4">
                  <span className="flex-shrink-0 w-6 h-6 bg-green-100 text-green-600 rounded-full flex items-center justify-center text-xs font-bold">✓</span>
                  <div>
                    <span className="text-xs font-bold text-green-600 uppercase tracking-wider">After</span>
                    <p className="text-sm text-warm-600 mt-0.5">{module.after}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Dashboard preview */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="bg-gradient-to-br from-hermes-800 to-hermes-900 rounded-3xl p-3 sm:p-6 shadow-2xl">
            <div className="bg-warm-900 rounded-2xl overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-3 bg-hermes-900/80 border-b border-hermes-700/30">
                <div className="w-3 h-3 rounded-full bg-hermes-500/60" />
                <div className="w-3 h-3 rounded-full bg-hermes-400/60" />
                <div className="w-3 h-3 rounded-full bg-green-400/60" />
                <span className="ml-3 text-xs text-warm-400 font-mono">dashboard.jkdcoding.com</span>
              </div>
              <img
                src={dashboardImg}
                alt="JKDCoding 系統後台儀表板"
                className="w-full h-auto"
              />
            </div>
          </div>
          {/* Floating badges */}
          <div className="absolute -top-4 -right-4 bg-hermes-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg">
            即時數據
          </div>
          <div className="absolute -bottom-4 -left-4 bg-green-600 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg">
            自動運行中
          </div>
        </motion.div>
      </div>
    </section>
  );
}
